import { VueModule } from '@Foundation/utilities';
import footerBanner from './code/Scripts/components/footer-banner.vue';

export default VueModule({
  components: {
    footerBanner
  }
});

